import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Item } from '../../../../components/Grid';
import HistoryRowControls from '../../../../components/HistoryRowControls';
import HistoryRowListing from '../../../../components/HistoryRowListing';
import HistorySection from '../../../../components/HistorySection';

import DocumentCreationButton from '../../../../components/DocumentCreationButton';
import DescriptionText from 'Routes/Updrs/utils/DescriptionText';

const UPDRSV = ({ documents, startEdit, view }: IOwnProps): React.JSX.Element => (
  <HistorySection
    headerText={<FormattedMessage id={'updrs.updrsV'} />}
    newButton={
      <DocumentCreationButton
        name="updrs_v"
        text={'updrs.newUpdrsV'}
        onClick={startEdit({}, 'updrs_v')}
        width={15}
        height={3}
        fontSize={14}
        alternate={true}
      />
    }
    headerInfoText={<DescriptionText type={'updrsV'} />}
  >
    <HistoryRowListing
      documents={documents}
      headers={
        <>
          <Item xs={4}>
            <FormattedMessage id={'updrs.score'} />
          </Item>
          <Item xs={8}>
            <FormattedMessage id={'general.definition'} />
          </Item>
        </>
      }
      contentFormat={(d: IUPDRSV): React.JSX.Element => (
        <>
          <Item xs={4}>{d.value ?? '-'}</Item>
          <Item xs={8} style={{ paddingRight: '1rem' }}>
            {d.value || d.value === 0 ? <FormattedMessage id={`updrs.opts.v.${d.value}`} /> : '-'}
          </Item>
        </>
      )}
      makeDate
      makeControls
      historyRowControls={(d: IControlProps) => <HistoryRowControls document={d} startEdit={startEdit} view={view} />}
    />
  </HistorySection>
);

interface IOwnProps {
  documents: IUPDRSV[];
  startEdit: (document: TAnyObject, name?: string) => (e: React.MouseEvent<Element, MouseEvent>) => void;
  view?: IView;
}

export default UPDRSV;
